import api from '@/utils/api';

const controller = 'v1.0/usuarioAutorizacao';
const usuarioAutorizacaoExport = Object.assign(
    {},
    api.GetCrud(controller, ["none"]),
    {
        ConfigurarAcesso: function (model) {
            return api.Axios.Post(controller, model);
        },
        VerificaAcesso: function (model) {
            return api.Axios.Get(controller + "/" + model.email);
        },
        GetTodos: function () {
            return api.Axios.Get(controller + "/Grupos");
        },
        Delete: function (id) {
            return api.Axios.Delete(controller + "/" + id);
        },
    }
);

export default usuarioAutorizacaoExport;